export const antAllocationStep = 0.1;
export const caloriesReserveMax = 4000;
export const caloriesReserveStart = 0;
export const caloriesReserveStep = 100;
export const caloriesStart = 200;
export const snapshotMinimumAntWorkers = 1;
export const snapshotMinimumCalories = 100;
export const snapshotMinimumCaloriesIncome = 10;
export const snapshotMinimumFoodCalories = 500;